import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSquareBehindSquare6: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconSquareBehindSquare6"><Path fillRule="evenodd" clipRule="evenodd" d="M7 3H21V17.01H17V21H3V7H7V3ZM17 15.51V7H8.5V4.5H19.5V15.51H17Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSquareBehindSquare6;
